import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Receipt, ReceiptListItem } from './receipt';
import { ReceiptService } from './receipt.service';
import { VendorService } from '../vendor/vendor.service';
import { Vendor } from '../vendor/vendor';
import { GUILogicService } from '../guilogic.service';

import { Message, ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css'],
  providers: [ConfirmationService]
})
export class ReceiptComponent implements OnInit {
  receiptList: ReceiptListItem[];
  msgs: Message[];
  selectedReceipt: Receipt;

  dataChartKPI : any;

  constructor(private receiptService: ReceiptService, private router: Router,
    private confirmationService: ConfirmationService, private vendorService: VendorService,
    private guiLogicService : GUILogicService) {
    this.receiptList = [];
    this.msgs = [];

    this.dataChartKPI = {
      datasets: [{
        data: [
          2,
          32,
          5,
          1,
          51
        ],
        backgroundColor: [
          "#FF6384",
          "#4BC0C0",
          "#FFCE56",
          "#E7E9ED",
          "#36A2EB"
        ],
        label: 'My dataset'
      }],
      labels: [
        "Offen",
        "Erledigt",
        "Inarbeit",
        "Angehalten",
        "Freigegeben",
      ]
    }
  }

  ngOnInit() {
    this.loadReceipts();
  }

  private loadReceipts() {
    this.receiptService.list().subscribe(
      (receiptArray: Receipt[]) => {
        console.log('Received list of receipts: ' + receiptArray.length);

        this.receiptList = [];
        for (var receipt of receiptArray) {
          let item: ReceiptListItem = new ReceiptListItem();

          item.id = receipt.id;
          item.hint = receipt.hint;
          item.gate = receipt.gate;
          item.receipt = receipt.receipt;
          item.state = receipt.state;
          if (receipt.positions != null)
            item.positionslength = receipt.positions.length;
          else
            item.positionslength = 0;

          // qry vendor from service
          this.vendorService.qryVendor(receipt.vendorid).subscribe(
            (vendor: Vendor) => {
              if (vendor != null)
                item.vendor = vendor;
              else
                item.vendor = new Vendor();
            },
            (err) => {
              console.log(err);
              item.vendor = new Vendor();
            }
          )

          this.receiptList = [...this.receiptList, item];
        }
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of receipts.' });
      }
    );
  }

  public addNew() {
    console.log('Navigate to new receipt component.');
    this.router.navigateByUrl('/receipt/new');
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    if (this.selectedReceipt == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Keine Wareneingang ausgewaehlt.' });
      return;
    }

    this.router.navigate(['/receipt', this.selectedReceipt.id])
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedReceipt == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Wareneingang ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den Wareneingang wirlich loeschen?',
      accept: () => {
        this.receiptService.delete(this.selectedReceipt.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Wareneingang wurde geloescht.' });
              this.loadReceipts();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Wareneingang konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Wareneingang konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  public releaseSelected() {
    this.msgs = [];
    if (this.selectedReceipt == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Wareneingang ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Möchten Sie den Wareneingang wirlich freigeben?',
      accept: () => {
        this.receiptService.release(this.selectedReceipt.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Wareneingang wurde freigegeben.' });
              this.loadReceipts();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Wareneingang konnte nicht freigegeben werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Wareneingang konnte nicht freigegeben werden.' });
            console.log(err);
          }
        );
      }
    });
  }

  public finishSelected() {
    this.msgs = [];
    if (this.selectedReceipt == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Wareneingang ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Möchten Sie den Wareneingang wirlich abschließen?',
      accept: () => {
        this.receiptService.finish(this.selectedReceipt.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Wareneingang wurde abgeschlossen.' });
              this.loadReceipts();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Wareneingang konnte nicht abgeschlossen werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Wareneingang konnte nicht abgeschlossen werden.' });
            console.log(err);
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/receipt/receipt.component.ts